import React from "react";

import {stringIsNotEmpty} from "src/servicos/lang/String";
import IUsuarioDrupal from "src/servicos/drupal/IUsuarioDrupal";
import IAuth0User from "src/servicos/auth0/IAuth0User";
import { auth0ToDrupalUser } from "src/servicos/usuario/IAppUser";

import { Theme, useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';

interface IProps {
	user?: IUsuarioDrupal | IAuth0User;
}

const UserTitle : React.FC<IProps> = (props) => 
{
	const _theme: Theme = useTheme();
	const { user } = props;

	if(!user) return <></>;

	// Convert Auth0 user to Drupal format if needed
	const drupalUser: IUsuarioDrupal = 'sub' in user 
		? auth0ToDrupalUser(user as IAuth0User) 
		: user as IUsuarioDrupal;

	return <div style={{marginTop: 8}}>
		{stringIsNotEmpty(drupalUser?.field_user_firstname) && 
			<Typography variant="subtitle2" display="block" align="center" style={{textTransform: "none", fontWeight: "bold"}}>
				{drupalUser?.field_user_firstname}
			</Typography>
		}

		{stringIsNotEmpty(drupalUser?.field_user_company?.title) && 
			<Typography variant="caption" display="block" align="center" style={{textTransform: "none"}}>
				{drupalUser?.field_user_company?.title}
			</Typography>
		}
	</div>
}

export default UserTitle